import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http, Headers, Response } from '@angular/http';
//import { MessageService } from '../services/message.service';
import { MessageService } from 'primeng/api';
import { StepComponent } from '../step/step.component';

import { StepService } from '../services/step.service';
import { ExerciseService } from '../services/exercise.service';
import { LanaService } from '../services/lana.service';
import { Step } from '../models/Step';
import { environment } from "./../../environments/environment";

import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';

import { ConfirmationService, TTResizableColumn } from "primeng/primeng";

import { Message } from 'primeng/api';
//import { $ } from 'protractor';
import * as $ from 'jquery';

import { FileUploader, FileSelectDirective } from 'ng2-file-upload/ng2-file-upload';
import { all } from 'q';
import { text } from '@angular/core/src/render3/instructions';
import { TranslateService } from "@ngx-translate/core";
//import { runInThisContext } from 'vm';

//const URL = 'http://localhost:3000/api/upload';

@Component({
  selector: 'app-step-menu',
  templateUrl: './step-menu.component.html',
  styleUrls: ['./step-menu.component.css']
})
export class StepMenuComponent implements OnInit {

  //@Input() stepComponent: StepComponent;
  @Input() step: Step;

  //@Output() public model = new EventEmitter<string>();
  @Output() stepDeleted = new EventEmitter<boolean>();

  environment: any = environment;

  description: string;
  title: string;
  help: string;
  order: number;
  id: string;
  addTexture: boolean = false;
  addModel: boolean = false;
  loading: boolean = false;
  nloaded: number = 0;
  daeModel: string;
  value: number = 0;


  selectedFile: string;
  //uploadedFiles: any[] = [];

  initialModels: any[] = [];
  correctModels: any[] = [];
  incorrectModels: any[] = [];
  helpFiles: any[] = [];

  uploadedFileInfo: any;
  uploadedDAE: any;
  textureList: any[] = [];
  texture: string = "";

  showModel: boolean = true;


  //correctModelsSubscription$: Observable<any>;

  exerciseId: string;

  msgs: Message[] = [];

  //public uploader: FileUploader = new FileUploader({ url: URL, itemAlias: 'photo' });

  constructor(private http: Http,
    private messageService: MessageService,
    public stepService: StepService,
    public exerciseService: ExerciseService,
    private lanaService: LanaService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private translate: TranslateService
  ) {
  }

  /*connectCorrectModels(data) {
    this.correctModels
  }*/

  ngOnInit() {
    //get step data
    /*console.log("****** ngOnInit STEP: ", this.step);
    this.title = this.step.title;
    this.description = this.step.description;
    this.exerciseId = this.step.exerciseId;
    this.help = this.step.help;
    this.order = this.step.order;
    this.id = this.step.id;
    this.initialModels = this.step.initialModels;
    this.correctModels = this.step.correctModels;
    this.incorrectModels = this.step.incorrectModels;
    this.helpFiles = this.step.helpFiles;
    if (this.helpFiles === undefined) { this.helpFiles = [] }

    if (this.initialModels.length > 0 || this.correctModels.length > 0) {
      console.log("ngOnInit: llamo a loadModels");
      this.lanaService.resetScene(this.loadModels, this);
    }
    else {
      console.log("ngOnInit:resetear escena y no hacer nada");
      this.lanaService.resetScene(function (p) { }, this);
    }*/
    //this.loadModels();

    this.lanaService.resetScene(function (p) { }, this);

  }

  ngOnChanges(changes) {
    if (changes.step.firstChange) {

    }
    else {
      this.title = this.step.title;
      this.description = this.step.description;
      this.exerciseId = this.step.exerciseId;
      this.help = this.step.help;
      this.order = this.step.order;
      this.id = this.step.id;
      this.initialModels = this.step.initialModels;
      this.correctModels = this.step.correctModels;
      this.incorrectModels = this.step.incorrectModels;
      this.helpFiles = this.step.helpFiles;
      if (this.helpFiles === undefined) { this.helpFiles = [] }

      if (this.initialModels.length > 0 || this.correctModels.length > 0) {
        this.lanaService.resetScene(this.loadModels, this);
      }
      else {
        this.lanaService.resetScene(function (p) { }, this);
      }
    }
  }

  onTitleChange(event) {
    this.step.title = this.title;
    this.stepService.editStep(this.step);
  }

  onDescriptionChange(event) {
    this.step.description = this.description;
    this.stepService.editStep(this.step);
  }

  onHelpChange(event) {
    this.step.help = this.help;
    this.stepService.editStep(this.step);
  }


  onCorrectUpload(event) {
    this.uploadedFileInfo = JSON.parse(event.xhr.response);
    this.showModel = true;
    this.uploadedFileInfo.url = environment.apiEndpoint + this.uploadedFileInfo.url;
    this.correctModels.push(this.uploadedFileInfo);
    let selected = this.uploadedFileInfo.name;
    //this.lanaService.addModel(uploadedFileInfo.url);
    this.daeModel = selected.substring(0, selected.indexOf(".")) + ".dae";
    this.addModel = true;

    this.saveMatrixTransforms(this.initialModels);
    this.saveMatrixTransforms(this.correctModels);
    this.step.initialModels = this.initialModels;
    this.step.correctModels = this.correctModels;
    this.stepService.editStep(this.step);

    this.stepService.getNumberSteps(this.exerciseId).subscribe(
      nsteps => {
        let count = nsteps.count;
        if (this.order < count - 1) {
          //Actualize next steps
          this.stepService.updateNextSteps(this.exerciseId, this.order, this.initialModels, this.correctModels, function () { }, this);
        }
      });
  }

  onIncorrectUpload(event) {
    this.uploadedFileInfo = JSON.parse(event.xhr.response);
    /*this.messageService.sendMessage({
      severity: "info",
      summary: this.translate.instant('Warning_Save_File_Title'),
      detail: this.translate.instant('Warning_Save_File', { value: uploadedFileInfo.name }),
    });*/
    this.showModel = false;
    this.uploadedFileInfo.url = environment.apiEndpoint + this.uploadedFileInfo.url;
    this.incorrectModels.push(this.uploadedFileInfo);
    let selected = this.uploadedFileInfo.name;
    //this.lanaService.addModel(uploadedFileInfo.url);
    this.daeModel = selected.substring(0, selected.indexOf(".")) + ".dae";
    this.addModel = true;

    //save step
    this.step.incorrectModels = this.incorrectModels;
    this.stepService.editStep(this.step);

  }

  onHelpUpload(event) {
    this.uploadedFileInfo = JSON.parse(event.xhr.response);
    this.uploadedFileInfo.url = environment.apiEndpoint + this.uploadedFileInfo.url;
    this.helpFiles.push(this.uploadedFileInfo);

    this.step.helpFiles = this.helpFiles;
    this.stepService.editStep(this.step);

  }

  onInitialUpload(event) {
    this.uploadedFileInfo = JSON.parse(event.xhr.response);
    this.showModel = true;
    this.uploadedFileInfo.url = environment.apiEndpoint + this.uploadedFileInfo.url;
    this.initialModels.push(this.uploadedFileInfo);
    let selected = this.uploadedFileInfo.name;
    this.daeModel = selected.substring(0, selected.indexOf(".")) + ".dae";
    this.addModel = true;

    this.saveMatrixTransforms(this.initialModels);
    this.saveMatrixTransforms(this.correctModels);
    this.step.initialModels = this.initialModels;
    this.step.correctModels = this.correctModels;
    this.stepService.editStep(this.step);

    this.stepService.getNumberSteps(this.exerciseId).subscribe(
      nsteps => {
        let count = nsteps.count;
        if (this.order < count - 1) {
          this.stepService.updateNextSteps(this.exerciseId, this.order, this.initialModels, this.correctModels, function () { }, this);
        }
      });
  }

  onUploadDAE(event) {
    this.addModel = false;
    this.uploadedDAE = JSON.parse(event.xhr.response);
    this.uploadedDAE.url = environment.apiEndpoint + this.uploadedDAE.url;
    //this.initialModels.push(this.uploadedFileInfo);

    var mydaeObj = this.getDAEInfo(this.uploadedDAE.url);

    var parser = new DOMParser();
    var xmlDoc = parser.parseFromString(mydaeObj, "text/xml");
    var library_images = xmlDoc.getElementsByTagName("library_images")[0];
    if (library_images !== undefined) {
      var x = library_images.getElementsByTagName("image")[0];
      for (var i = 0; i < library_images.childElementCount; i++) {
        var image = library_images.getElementsByTagName("init_from")[i];
        let img = image.childNodes[0].nodeValue;
        this.textureList[i] = img.substring(img.indexOf('/') + 1);
      }
    }
    //var image = x.getElementsByTagName("init_from")[0];
    /*for (let i of image.childNodes) {
      this.textureList[i] = image.childNodes[i].nodeValue;
    }*/
    //this.texture = image.childNodes[0].nodeValue;
    //this.texture = this.texture.substring(this.texture.indexOf('/') + 1);
    if (this.textureList.length > 0) {
      this.addTexture = true;
    }
    else {
      let params = {
        this: this,
        nModel: 1,
        numModels: 1
      }
      this.loading = true;
      let matrix = { "elements": { 0: 1, 1: 1, 2: 1, 3: 1, 4: 1, 5: 1, 6: 1, 7: 1, 8: 1, 9: 1, 10: 1, 11: 1, 12: 1, 13: 1, 14: 1, 15: 1 } }
      this.lanaService.addModel(this.uploadedDAE.url, matrix, this.updateProgessBar, params);
    }
  }

  onInitialSelect(event) {
    for (let file in event.files) {
    }
  }

  onUploadTexture(event, i) {
    var index = this.textureList.indexOf(i);
    if (index > -1) {
      this.textureList.splice(index, 1);
    }

    if (this.textureList.length <= 0) {
      this.addTexture = false;
    }
    if (this.showModel) {
      let params = {
        this: this,
        nModel: 1,
        numModels: 1
      }
      this.loading = true;
      let matrix = { "elements": { 0: 1, 1: 1, 2: 1, 3: 1, 4: 1, 5: 1, 6: 1, 7: 1, 8: 1, 9: 1, 10: 1, 11: 1, 12: 1, 13: 1, 14: 1, 15: 1 } }
      this.lanaService.addModel(this.uploadedDAE.url, matrix, this.updateProgessBar, params);
    }
    this.texture = "";
  }

  showAddTexture(texture: string) {
    this.addTexture = true;
  }



  cancelAddTexture() {
    this.addTexture = false;
  }

  cancelAddDAE() {
    this.addModel = false;
  }

  hasInitialModels() {
    if (this.initialModels.length > 0) {
      return true;
    }
  }

  hasCorrectModels() {
    if (this.correctModels.length > 0) {
      return true;
    }
  }

  hasIncorrectModels() {
    if (this.incorrectModels.length > 0) {
      return true;
    }
  }

  hasHelpFiles() {
    if (this.helpFiles.length > 0) {
      return true;
    }
  }

  save() {
    this.saveMatrixTransforms(this.initialModels);
    this.saveMatrixTransforms(this.correctModels);
    let newStep: Step;
    newStep = this.step;
    newStep.title = this.title;
    newStep.description = this.description;
    newStep.exerciseId = this.exerciseId;
    newStep.help = this.help;
    newStep.initialModels = this.initialModels;
    newStep.correctModels = this.correctModels;
    newStep.incorrectModels = this.incorrectModels;
    newStep.helpFiles = this.helpFiles;
    newStep.id = this.id;
    this.stepService.editStep(newStep);



    //To save update Date
    this.exerciseService.getByExerciseId(this.exerciseId).subscribe(
      exercise => {
        let myExercise = exercise[0];
        this.exerciseService.editExercise(myExercise);
      }
    );


    let summary = this.translate.instant('Saved');
    let detail = this.translate.instant('Correctly_Saved');
    this.messageService.add({ severity: 'success', summary: summary, detail: detail });
    //this.showInfo(summary, detail);
  }

  saveMatrixTransforms(models) {
    models.forEach(element => {
      element.matrixWorld = this.lanaService.getMatrixWorld(element.name);
    });

  }


  confirmDelete() {
    this.confirmationService.confirm({
      message: this.translate.instant('Are_You_Sure'),
      accept: () => {
        //Actual logic to perform a confirmation
        this.delete();
      }
    });
  }

  delete() {
    let stepId = this.step.id;
    let stepOrder = this.step.order;
    this.stepService.deleteStep(stepId);

    //TODO: Modificar orden de los pasos posteriores:
    this.stepService.renumberSteps(this.exerciseId, this.order, this.reloadExerciseSteps, this);
    //this.stepComponent.update();
    let summary = this.translate.instant('Deleted');
    let detail = this.translate.instant('Correctly_Deleted');
    this.messageService.add({ severity: 'success', summary: summary, detail: detail });
    //this.showInfo(summary, detail);
  }

  reloadExerciseSteps(self: any) {
    //console.log("emitStepDeleted")
    self.stepDeleted.emit(true);
  }

  /*showInfo(summary: string, detail: string) {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: summary, detail: detail });
  }*/


  deleteInitialModel(model) {
    var index = this.initialModels.indexOf(model);
    if (index > -1) {
      this.initialModels.splice(index, 1);
      let mydaeObj = model.url;
      mydaeObj = mydaeObj.substring(0, mydaeObj.indexOf(".viwork")) + ".dae";
      this.lanaService.deleteModel(mydaeObj);
      this.step.initialModels = this.initialModels;
      this.stepService.editStep(this.step);
      //this.lanaService.resetScene();
      this.stepService.getNumberSteps(this.exerciseId).subscribe(
        nsteps => {
          let count = nsteps.count;
          if (this.order < count - 1) {
            this.stepService.updateNextSteps(this.exerciseId, this.order, this.initialModels, this.correctModels, function () { }, this);
          }
        });
    }
  }

  deleteCorrectModel(model) {
    var index = this.correctModels.indexOf(model);
    if (index > -1) {
      this.correctModels.splice(index, 1);
      let mydaeObj = model.url;
      mydaeObj = mydaeObj.substring(0, mydaeObj.indexOf(".viwork")) + ".dae";
      this.lanaService.deleteModel(mydaeObj);
      this.step.correctModels = this.correctModels;
      this.stepService.editStep(this.step);
      //this.lanaService.resetScene();
      this.stepService.getNumberSteps(this.exerciseId).subscribe(
        nsteps => {
          let count = nsteps.count;
          if (this.order < count - 1) {
            this.stepService.updateNextSteps(this.exerciseId, this.order, this.initialModels, this.correctModels, function () { }, this);
          }
        });
    }
  }

  deleteIncorrectModel(model) {
    var index = this.incorrectModels.indexOf(model);
    if (index > -1) {
      this.incorrectModels.splice(index, 1);
      this.step.incorrectModels = this.incorrectModels;
      this.stepService.editStep(this.step);
    }
  }

  deleteHelpFiles(file) {
    var index = this.helpFiles.indexOf(file);
    if (index > -1) {
      this.helpFiles.splice(index, 1);
      this.step.helpFiles = this.helpFiles;
      this.stepService.editStep(this.step);
    }
  }

  getJson(url) {
    return JSON.parse($.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      global: false,
      async: false,
      success: function (data) {
        return data;
      }
    }).responseText);
  }

  getDAEInfo(url) {
    return $.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      global: false,
      async: false,
      success: function (data) {
        return data;
      }
    }).responseText;
  }

  loadModels(self: any) {

    //this.lanaService.resetScene();

    let numModels = self.initialModels.length + self.correctModels.length;
    let sum = 100 / numModels;
    let nModel = 1;
    let matrix;


    if (self.initialModels.length > 0) {

      for (let initialModel of self.initialModels) {
        let params = {
          this: self,
          nModel: nModel,
          numModels: numModels
        }
        self.loading = true;
        let mydaeObj = initialModel.url;
        mydaeObj = mydaeObj.substring(0, mydaeObj.indexOf(".viwork")) + ".dae";
        //numModels = numModels - 1;
        //if (this.lanaService.addModel(mydaeObj) && (numModels === 0)) { this.loading = false }
        if (initialModel.matrixWorld === undefined || initialModel.matrixWorld === null) {
          matrix = { "elements": { 0: 1, 1: 1, 2: 1, 3: 1, 4: 1, 5: 1, 6: 1, 7: 1, 8: 1, 9: 1, 10: 1, 11: 1, 12: 1, 13: 1, 14: 1, 15: 1 } }
        }
        else {
          matrix = initialModel.matrixWorld;
        }
        self.lanaService.addModel(mydaeObj, matrix, self.updateProgessBar, params);
        self.value = self.value + sum;
        nModel = nModel + 1;

        /*if (this.value >= 100) {
          this.loading = false;
        }*/
      }
    }
    if (self.correctModels.length > 0) {

      for (let correctModel of self.correctModels) {
        let params = {
          this: self,
          nModel: nModel,
          numModels: numModels
        }
        self.loading = true;
        let mydaeObj = correctModel.url;
        mydaeObj = mydaeObj.substring(0, mydaeObj.indexOf(".viwork")) + ".dae";
        if (correctModel.matrixWorld === undefined) {
          matrix = { "elements": { 0: 1, 1: 1, 2: 1, 3: 1, 4: 1, 5: 1, 6: 1, 7: 1, 8: 1, 9: 1, 10: 1, 11: 1, 12: 1, 13: 1, 14: 1, 15: 1 } }
        }
        else {
          matrix = correctModel.matrixWorld;
        }
        //let matrix = { "elements": { 0: 1, 1: 1, 2: 1, 3: 1, 4: 1, 5: 1, 6: 1, 7: 1, 8: 1, 9: 1, 10: 1, 11: 1, 12: 1, 13: 1, 14: 1, 15: 1 } }
        self.lanaService.addModel(mydaeObj, matrix, self.updateProgessBar, params);
        //if (this.lanaService.addModel(mydaeObj)) { this.loading = false }
        //numModels = numModels - 1;
        //this.lanaService.addModel(mydaeObj, this.updateProgessBar, this);
        //if (this.lanaService.addModel(mydaeObj) && (numModels === 0)) { this.loading = false }

        self.value = self.value + sum;

        /*if (this.value >= 100) {
          this.loading = false;
        }*/
      }
    }
    //this.loading = false;
  }

  updateProgessBar(params) {
    params.this.nloaded = params.this.nloaded + 1;
    if (params.this.nloaded === params.numModels) {
      params.this.loading = false;
      params.this.nloaded = 0;
    }

  }
}

//}
